<template>
<!--   已经不用了 编辑委托生产单-->
    <div class="ed video-tree">
        <el-form  :model="formData" :rules="formRules" ref="formRef" label-width="80px" size="mini">
            <h3 style="text-align: center;"><span v-if="i_id==0">{{$t('button_newly_added')}}</span>{{$t('promanagement_commissioned_production_task_order')}}</h3>
                <el-form-item class="form-title num" prop="num" label="No:" >
                    <span  v-model="formData.num" style="color:#b3d268;font-size: 16px;font-style: italic;width: 150px;">{{formData.num}}</span>
                </el-form-item>
                <div class="item">
                    <el-form-item class="form-title" prop="wtname" :label="$t('form_entrust_company')" >
                        <el-select v-model="formData.wtname" :placeholder="$t('form_please_select_the_commissioning_company')" @change="changeCompanywt" filterable required clearable :disabled="edit">
                            <el-option
                                    v-for="item in wtcompanyName"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                                <!--                                <span  style="display: inline-block;width: 100%">{{item.vc_name}}</span>-->
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="gsname" :label="$t('form_processing_company')" >
                        <el-select v-model="formData.gsname" :placeholder="$t('form_please_select_a_processing_company')" @change="changeCompany" filterable required clearable :disabled="edit">
                            <el-option
                                    v-for="item in companyName"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                                <!--                                <span  style="display: inline-block;width: 100%">{{item.vc_name}}</span>-->
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="cjname" :label="$t('form_workshop_department')" >
                        <el-select v-model="formData.cjname" :placeholder="$t('form_please_select_department')" @change="changeGroup" filterable required clearable :disabled="edit">
                            <el-option
                                    v-for="itembm in groupName"
                                    :key="itembm.i_id"
                                    :label="itembm.vc_name"
                                    :value="itembm.i_id">
                                <!--                                <span  style="display: inline-block;width: 100%">{{itembm.vc_name}}</span>-->
                            </el-option>

                        </el-select>
                    </el-form-item>
<!--                    <el-form-item class="form-title" prop="zdname" label="制单人" >-->
<!--                        <el-select v-model="formData.zdname" placeholder="请选择制单人"  @change="changePerson" filterable required clearable :disabled="edit">-->
<!--                            <el-option-->
<!--                                    v-for="itemsq in personName"-->
<!--                                    :key="itemsq.i_id"-->
<!--                                    :label="itemsq.vc_name"-->
<!--                                    :value="itemsq.i_id">-->
<!--                                &lt;!&ndash;                                <span style="display: inline-block;width: 100%">{{itemsq.vc_name}}</span>&ndash;&gt;-->
<!--                            </el-option>-->

<!--                        </el-select>-->
<!--                    </el-form-item>-->
                </div>
                <div class="item">
                    <el-form-item class="form-title" prop="proname" :label="$t('form_product')" >
                        <el-select v-model="formData.proname" :placeholder="$t('form_please_select_a_product')" @change="changePro" filterable required clearable :disabled="edit">
                            <el-option
                                    v-for="one in proList"
                                    :key="one.i_id"
                                    :label="one.vc_pzname"
                                    :value="one.i_id">
                                <!--                                <span  style="display: inline-block;width: 100%">{{one.vc_name}}</span>-->
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="ckname" :label="$t('form_warehouse')" >
                        <el-select v-model="formData.ckname" :placeholder="$t('form_please_select_warehouse')"  @change="changeWarehouse" filterable required clearable :disabled="edit">
                            <el-option
                                    v-for="one in warehouseName"
                                    :key="one.i_id"
                                    :label="one.vc_name"
                                    :value="one.i_id">
                                <!--                                <span  style="display: inline-block;width: 100%">{{one.vc_name}}</span>-->
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-title" prop="f_num" :label="$t('form_quantity')" >
                        <el-input-number type="number" :disabled="this.i_id!==0"  :controls="false" :precision="2" :min="0" v-model.number="formData.f_num" >
                        </el-input-number>
                    </el-form-item>
                    <!--<el-form-item class="form-title" prop="jgcost" label="加工单价" >
                        <el-input-number :controls="false" :precision="2"  v-model="formData.jgcost" >
                        </el-input-number>
                    </el-form-item>-->
                </div>
                <div class="item">

                    <el-form-item class="form-title" prop="begintime" :label="$t('form_start_time')" >
                        <el-date-picker
                                @change="getLastDay"
                                disabled
                                v-model="formData.begintime"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                type="date"
                                :placeholder="$t('form_select_date')">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class="form-title" prop="endtime" :label="$t('form_end_time')" >
                        <el-date-picker
                                :picker-options="pickerOptions"
                                disabled
                                v-model="formData.endtime"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                type="date"
                                :placeholder="$t('form_select_date')">
                        </el-date-picker>
                    </el-form-item>

                </div>

            <el-form-item class="form-title" prop="vc_note" :label="$t('form_notes')" >
                <el-input  v-model="formData.vc_note" >
                </el-input>
            </el-form-item>
            <div class="formDiv flex">
            <el-form-item class="form-title" prop="vc_lruname" :label="$t('form_creator')" >
                <el-input  v-model="formData.vc_lruname" disabled>
                </el-input>
            </el-form-item>
            <el-form-item class="form-title" prop="date" :label="$t('form_date')" >
                <el-input  v-model="formData.date" disabled>
                </el-input>
            </el-form-item>
        </div>
            <el-form-item class="form-title" >

            <el-table
                    @row-click="selectItem"
                    ref="baseForm"
                    border
                    :data="formData.tableData"
                    style="width: 100%;max-height: 350px;overflow: auto;min-width: 940px">
                <template slot="empty">
                <span @click="addRow">{{$t('promanagement_click_to_add_plan')}}</span>
                </template>
                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column
                        min-width="190"
                        :label="$t('form_date')"
                        show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-date-picker
                                @change="datechange"
                                :disabled="scope.row.i_id!==0"
                                :picker-options="pickerOpt"
                                :default-value="timeDefaultShow"
                                value-format="yyyy-MM-dd"
                                style="width: 160px;"
                                        v-model="scope.row.dt_day"
                                        type="date"
                                        :placeholder="$t('form_select_date')">
                        </el-date-picker>
<!--                        <el-input style="width: 160px;"-->
<!--                                  placeholder="请输入"-->
<!--                                  v-model="scope.row.count"-->
<!--                                  clearable-->
<!--                                  @blur="totalcount">-->
<!--                        </el-input>-->
                    </template>
                </el-table-column>
                <el-table-column
                        min-width="190"
                        prop="name"
                        :label="$t('promanagement_planned_quantity')"
                        show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-input
                                :disabled="scope.row.i_id!==0"
                                type="number"
                               step="0.01"
                                style="width: 160px;"
                                  :placeholder="$t('promanagement_please_enter_the_content')"
                                  v-model.number="scope.row.f_num"
                                  clearable
                                  @blur="totalcount">
                        </el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        min-width="190"

                        :label="$t('form_input_person')"
                        show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-input
                                style="width: 160px;"
                                  :placeholder="$t('promanagement_please_enter_the_content')"
                                  v-model.trim="scope.row.vc_lruname"
                                  clearable
                                  disabled>
                        </el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        min-width="190"

                        :label="$t('form_enter_time')"
                        show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-input style="width: 160px;"
                                  :placeholder="$t('promanagement_please_enter_the_content')"
                                  v-model="scope.row.dt_createtime"
                                  clearable
                                  disabled>
                        </el-input>
                    </template>
                </el-table-column>
                    <el-table-column
                            min-width="120"

                            :label="$t('form_operate')"
                    show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-plus" @click="addLine"></el-button>
                            <el-button v-if="scope.row.i_id==0" type="text" icon="el-icon-minus"  @click.native.prevent="deleteRow(scope.$index, formData.tableData,scope.row)"></el-button>
                        </template>
            </el-table-column>
            </el-table>
            </el-form-item>
            <el-form-item class="form-title form-heji" :label="$t('promanagement_amount_to')" style="color: black">
<!--                <el-input style="width: 160px;"  v-model="total" >-->
<!--                </el-input>-->
<!--                <el-input-number type="number" disabled  :controls="false" :precision="2" :min="0" v-model.number="formData.total" >-->
<!--                </el-input-number>-->
                {{formData.total}}
            </el-form-item>
        </el-form>
        <div slot="footer"  class="dialog-footer" style="text-align: center">
<!--            <el-button @click="cancel">取 消</el-button>-->
            <el-button type="primary" @click="saveForm" :class="baseerp+'btn'" :disabled="disabled"  size="mini">{{$t('button_save')}}</el-button>
            <!--            <el-button type="warning" @click="submitForm" :disabled="i_outid==0" >提交</el-button>-->
            <!--            <el-button type="danger" @click="invalidForm" :disabled="disabled" v-if="i_outid!=0">作废</el-button>-->
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "EntrustDetails",
        props:{
            formvalue:{
                type:Object,
                required:true,

            },
            datevalue:{
                type:String
            }
        },
        data() {
            return {
                index:0,
                pickerOpt:{
                    disabledDate: (time) => {
                        return this.Disabledate(time)
                    }
                },
                disable:false,
                baseerp:"",
                total:[],
                // tableData: [{
                //     i_id:0,
                //     f_num:0,
                //     i_lruid:sessionStorage.getItem("userid"),
                //     i_pid:0,
                //     vc_lruname:sessionStorage.getItem("lruname"),
                //     dt_createtime:'',
                //     dt_day:''
                // }],
                timeDefaultShow:'',
                edit:false,
                formData:{
                    wtname:"",
                    gsname:"",
                    zdname:"",
                    cjname:"",
                    proname:"",
                    ckname:"",
                    begintime:"",
                    endtime:"",
                    f_num:0,
                    jgcost:0,
                    num:"000000",
                    vc_note:"",
                    vc_lruname:"",
                    date:"",
                    preparationDate:'',
                    tableData: [
                    ],
                    total:0,
                    delList:[],//删除数组
                },
                proname:"",
                formRules:{

                   /* wtname:[{required:true,message:"请选择委托公司",trigger:"change"}],
                    gsname:[{required:true,message:"请选择加工公司",trigger:"change"}],
                    cjname:[{required:true,message:"请选择车间",trigger:"change"}],
                    zdname:[{required:true,message:"请选择制定人",trigger:"change"}],
                    proname:[{required:true,message:"请选择产品",trigger:"change"}],
                    ckname:[{required:true,message:"请选择仓库",trigger:"change"}],
                    jgcost:[{required:true,message:"请输入加工费",trigger:"blur"}],
                    shul:[{required:true,message:"请输入数量",trigger:"blur"}],
                    endtime:[{required:true,message:"请选择结束日期",trigger:"change"}],
                    begintime:[{required:true,message:"请选择开始日期",trigger:"change"}],*/
                },
                wtcompanyName:[],
                companyName:[],
                groupName:[],
                personName:[],
                proList:[],
                warehouseName:[],
                gsid:0,
                ckid:0,
                pzid:0,
                cjid:0,
                i_id:0,
                i_type:9,
                wtgsid:0,
                zduid:0,
                pzname:"",
                zdname:"",
                wtname:"",
                gsname:"",
                cjname:"",
                lastTime:"",
                disabled:false,
                mid:0,
                startenddate:'',
                olddata:[],
                newdata:[],
                saveList:[],
                deli_id:0
            }
        },
        watch:{
            datevalue(){
                if (this.datevalue){
                    //console.log("datevalue_watch",this.datevalue)
                    this.timeDefaultShow=new Date(this.datevalue)
                    // this.getScorder();
                    // this.taskList()
                    // console.log(this.formvalue,"this.formvalue");

                }
            },

            formvalue:{
                handler(){
                    if (this.formvalue) {
                        // this.currentDate()

                        //this.disabled=false;
                        this.mid=this.formvalue.i_mid;
                        if (this.i_id != this.formvalue.i_id) {
                            //console.log("1");
                            this.form = this.formvalue;
                            this.currentDate()

                            this.i_id = this.form.i_id;
                            this.i_type = this.form.i_type;
                            //this.disabled = false;
                            if ((this.form.i_id ?? '' !== '') && this.i_id != 0) {
                                //console.log("3")
                                this.edit = true;
                                this.getScorder();

                                // this.currentDate()

                                if (this.formvalue.value.dt_createtime>=this.formvalue.value.dt_starttime&&this.formvalue.value.dt_createtime<=this.formvalue.value.dt_endtime){
                                    this.disabled=false;
                                  //  console.log(this.formvalue.value.dt_createtime,this.formvalue.value.dt_starttime,this.formvalue.value.dt_endtime,"check")
                                }else{
                                    this.disabled=true;
                                };
                            }else if(this.i_id==0){
                                // this.getScorder();
                                //console.log("4")
                                this.newData();
                                //this.currentDate()
                            }

                           // console.log(this.form,"this.form");
                        }else if (this.i_id == 0&&(this.i_type!=this.formvalue.i_type)) {
                            // this.getScorder();
                            //console.log("2");
                            this.newData();
                            //this.currentDate()

                        }
                    }
                },
                immediate:true,
                deep:true
            }

        },
        mounted() {
            // if(this.datevalue==0){

                this.timeDefaultShow=new Date(this.datevalue)
            // }
            // this.getScorder()
            this.gettime()
            // console.log(this.datevalue)
            // this.formData.vc_lruname=sessionStorage.getItem("lruname"),;
            this.baseerp=baseerp;
            this.olddata=JSON.parse(JSON.stringify(this.formData.tableData))

        },
        computed:{
            //禁止跨月
            pickerOptions(){
                let _this = this

                return {
                    disabledDate(time) {
                        let start = new Date(_this.lastTime);
                        start.setDate(start.getDate());
                        return time.getTime() > start.getTime();
                    }
                }
            }
        },
        methods: {
            //判断表格内时间
            Disabledate(time){
                var now = new Date(); //当前日期
                let searchdate=this.datevalue.substring(5,7)
                // console.log(searchdate)
                var nowMonth = now.getMonth(); //当前月
                // console.log(nowMonth)
                var nowYear = now.getFullYear(); //当前年
                var monthEndDate = new Date(nowYear, nowMonth + 1, 0);
                let newnowMonth=0
                if(nowMonth<10){
                     newnowMonth='0'+(nowMonth+1)
                }else {
                     newnowMonth=nowMonth+1+''
                }
                // console.log(searchdate==newnowMonth)
                if(searchdate==newnowMonth){
                    return time.getTime()<Date.now()-8.64e7||time.getTime()>monthEndDate;
                }else {
                    const date = new Date(this.datevalue)
                    const year = date.getFullYear()
                    let month = date.getMonth() + 1
                    if (month >= 1 && month <= 9) {
                        month = '0' + month
                    }
                    const currentdate = year.toString() + month.toString()
                    const timeyear = time.getFullYear()
                    let timemonth = time.getMonth() + 1
                    if (timemonth >= 1 && timemonth <= 9) {
                        timemonth = '0' + timemonth
                    }
                    const timedate = timeyear.toString() + timemonth.toString()
                    // 当月
                    return timedate < currentdate || currentdate < timedate

                }

            },
            //table没数据时点击新增
            addRow(){
                this.addLine()
            },
            datechange(e){
                // console.log(1)
            },
            gettime(){
                var date=new Date;
//获得页面的日期
                var this_month = this.datevalue;
                var this_year =  date.getFullYear();
                var this_month_dateTotal ="";

//将获得到的日期做字符串截取
                        this_month=this_month.substring(5,7)

//判断大小月

                if(this_month==2){
                    this_month_dateTotal=28
                }

                if(this_month==4||this_month==6||this_month==9||this_month==11){
                    this_month_dateTotal=30
                }

                if(this_month==1||this_month==3||this_month==5||this_month==7||this_month==8||this_month==10){
                    this_month_dateTotal=31
                }

                let thisStartDate=this_month+"/1/"+this_year;
                let  thisEndDate=this_month+"/"+this_month_dateTotal+"/"+this_year;
                // console.log(thisStartDate,thisEndDate,123123)
                // console.log("//年:"+this_year+"//获得月份为:"+this_month+"//当月天数:"+this_month_dateTotal)
            },

            currentDate(){
                var date = new Date(this.datevalue) // this.startTime = '2022-5-02'
                var new_year = date.getFullYear() // 取当前的年份
                var month = date.getMonth()

                var new_month = month + 1 // 取当前的月份
                if (month > 12) {
                    new_month -= 12 // 月份减
                    new_year++ // 年份增
                }
                var firstDay = new Date(new_year, new_month, 1) // 取当年当月中的第一天

                var lastDay = new Date(firstDay.getTime() - 1000 * 60 * 60 * 24).getDate() // 获取当月最后一天日期
                if(new_month==12&&firstDay.getMonth()==0){
                    // if (firstDay.getMonth() < 10) {
                    // var mon =  firstDay.getMonth()-1+"0"
                    // } else {
                    var mon = 12
                    var newfullyear=firstDay.getFullYear()-1
                    // }
                }else{
                    if (firstDay.getMonth() < 10) {
                        var mon = "0" + firstDay.getMonth()
                    } else {
                        var mon = firstDay.getMonth()
                    }
                    var newfullyear=firstDay.getFullYear()

                }
                var startDate = newfullyear + '-' + mon + '-' + "0" + firstDay.getDate();
                var endDate = newfullyear + '-' + mon + '-' + lastDay;
                this.formData.begintime=startDate
                this.formData.endtime=endDate
                //console.log("currentDate",this.formData.begintime,this.formData.endtime)
            },
            totalcount(){
                //计算合计
                let total=this.formData.tableData.map(item=>{
                    return  item.f_num
                })
                // console.log(total)
                let total1=total.map(Number)
                let total2=total1.reduce(function (sum, current) {
                    return sum + current;
                }, 0);
                this.formData.total=total2.toFixed(2)
                this.formData.tableData.forEach(item=>{
                    parseFloat(item.f_num)
                })
                // console.log(this.formData.tableData)
                // console.log(val)
            },
            // 删除指定行
            deleteRow(index, rows,val) {
                // let arr2=this.tableData.filter(item=>{
                //     return item==index
                // })
                this.deli_id=1
                if(val.i_id!==0){


                    this.total.unshift(val.i_id)
                    this.formData.delList=[]

                    // console.log( this.formData.delList)
                }else {
                    this.formData.delList=[]
                }
                // console.log(this.formData.tableData.length)
                rows.splice(index, 1);
                // console.log(val)

                // // 如果全部删除后没有可以点击的一行了，需要加一行空行
                // if (this.formData.tableData.length==0) {
                //     // this.addLine()
                // }
            },

            //增加行
            addLine () {

                const newLine = {
                    i_id:0,
                    f_num:0,
                    i_lruid:sessionStorage.getItem("userid"),
                    i_pid:0,
                    vc_lruname:sessionStorage.getItem("lruname"),
                    dt_createtime:'',
                    dt_day:''
                }
                this.index++
                this.formData.tableData.push(newLine)
                // this.disable=true
            },
            selectItem(row, column, event) {


            },

            //新增赋值
            newData(){
                /*this.formRules={
                    wtname:[{required:true,message:"请选择委托公司",trigger:"change"}],
                    gsname:[{required:true,message:"请选择加工公司",trigger:"change"}],
                    cjname:[{required:true,message:"请选择车间",trigger:"change"}],
                    zdname:[{required:true,message:"请选择制定人",trigger:"change"}],
                    proname:[{required:true,message:"请选择产品",trigger:"change"}],
                    ckname:[{required:true,message:"请选择仓库",trigger:"change"}],
                    jgcost:[{required:true,message:"请输入加工费",trigger:"blur"}],
                    shul:[{required:true,message:"请输入数量",trigger:"blur"}],
                    endtime:[{required:true,message:"请选择结束日期",trigger:"change"}],
                    begintime:[{required:true,message:"请选择开始日期",trigger:"change"}],
                },*/
                //console.log("datevalue",this.datevalue)
                var date = new Date() // this.startTime = '2022-5-02'
                var new_year = date.getFullYear() // 取当前的年份
                var month = date.getMonth()

                var new_month = month + 1 // 取当前的月份
                if (month > 12) {
                    new_month -= 12 // 月份减
                    new_year++ // 年份增
                }
                var firstDay = new Date(new_year, new_month, 1) // 取当年当月中的第一天

                var lastDay = new Date(firstDay.getTime() - 1000 * 60 * 60 * 24).getDate() // 获取当月最后一天日期
                if(new_month==12&&firstDay.getMonth()==0){
                    // if (firstDay.getMonth() < 10) {
                    // var mon =  firstDay.getMonth()-1+"0"
                    // } else {
                    var mon = 12
                    var newfullyear=firstDay.getFullYear()-1
                    // }
                }else{
                    if (firstDay.getMonth() < 10) {
                        var mon = "0" + firstDay.getMonth()
                    } else {
                        var mon = firstDay.getMonth()
                    }
                    var newfullyear=firstDay.getFullYear()

                }
                var startDate = newfullyear + '-' + mon + '-' + "0" + firstDay.getDate();
                var endDate = newfullyear + '-' + mon + '-' + lastDay;
                this.form=this.formvalue;
                this.i_id=this.form.i_id;
                this.i_type=this.form.i_type;
                //this.disabled = false;
                //console.log(this.datevalue,'datevalue')
                if(this.datevalue){
                    const nowT = Number((newfullyear + '-' + mon).replace("-", ""));
                    const dateT =  Number(this.datevalue.replace("-", ""));
                    if(nowT>dateT){
                        this.disabled=true;
                    }else{
                        this.disabled=false;
                    }
                }
                this.formData = {
                    begintime:startDate,
                    endtime:endDate,
                    wtname:'',
                    gsname:'',

                    cjname:"",
                    proname:"",
                    ckname:'',

                    jgcost:0,
                    vc_note:"",
                    date:"",
                    f_num: 0,
                    num: "000000",
                    vc_lruname: sessionStorage.getItem("lruname"),
                    tableData: [],
                    total:0
                };
                //console.log(this.formData.begintime,'newData')
                //console.log("new",this.formData.begintime,this.formData.endtime)
                this.edit = false;
                this.getCompanyList();
                this.getCompanyListwt();
                this.getGroupList();
                this.getWarehouseList();
                this.getDateYYYYMMddHHMMSS();
            },
            async getScorder(){
                let param={
                    i_mid: this.mid,
                    i_type:this.i_type,
                    i_id:this.i_id,
                };
                let res=await API.getScorder(param);
                if(res.code==1){
                    this.startenddate=res.data.dt_starttime.substring(0,7)
                    // console.log(this.startenddate)
                    var date = new Date(this.startenddate) // this.startTime = '2022-5-02'
                    var new_year = date.getFullYear() // 取当前的年份
                    var month = date.getMonth()

                    var new_month = month + 1 // 取当前的月份
                    if (month > 12) {
                        new_month -= 12 // 月份减
                        new_year++ // 年份增
                    }
                    var firstDay = new Date(new_year, new_month, 1) // 取当年当月中的第一天

                    var lastDay = new Date(firstDay.getTime() - 1000 * 60 * 60 * 24).getDate() // 获取当月最后一天日期
                    if(new_month==12&&firstDay.getMonth()==0){
                        // if (firstDay.getMonth() < 10) {
                        // var mon =  firstDay.getMonth()-1+"0"
                        // } else {
                        var mon = 12
                        var newfullyear=firstDay.getFullYear()-1
                        // }
                    }else{
                        if (firstDay.getMonth() < 10) {
                            var mon = "0" + firstDay.getMonth()
                        } else {
                            var mon = firstDay.getMonth()
                        }
                        var newfullyear=firstDay.getFullYear()

                    }
                    var startDate = newfullyear + '-' + mon + '-' + "0" + firstDay.getDate();
                    var endDate = newfullyear + '-' + mon + '-' + lastDay;
                    // this.formData.endtime=endDate
                    // console.log(res,'123')
                    let count=res.data.list.map(item=>{
                        return item.f_num
                    })
                    let count1=count.reduce(function (sum, current) {
                        return sum + current;
                    }, 0);
                    // console.log()
                    let data=res.data;
                    // this.formRules={};
                    this.formData={
                        wtname:data.vc_gsname,
                        gsname:data.vc_outgsname,
                        cjname:data.vc_cjname,

                        proname:data.vc_pzname,
                        ckname:data.vc_ckname,
                        // jgcost:data.f_fcost_price,
                        num:data.vc_pno,
                        vc_note:data.vc_note,
                        vc_lruname:data.vc_lruname,
                        date:data.dt_createtime,
                        tableData:data.list,
                        total:count1.toFixed(2),
                        f_num:data.f_num,
                        //begintime:startDate,
                        //endtime:endDate
                        begintime:data.dt_starttime,
                        endtime:data.dt_endtime,
                    };
                    //console.log("getScorder",this.formData.begintime,this.formData.endtime)
                    // this.
                    this.olddata=JSON.parse(JSON.stringify(this.formData.tableData.map(item=>({
                        i_id:item.i_id,
                        f_num:item.f_num,
                        i_lruid:sessionStorage.getItem("userid"),
                        i_pid:item.i_pid,
                        dt_day:item.dt_day
                    }))))
                    // console.log()
                    this.wtgsid=data.i_gsid;
                    this.gsid=data.i_gsid_out;
                    this.cjid=data.i_cjid;
                    this.ckid=data.i_ckid;
                    this.pzid=data.i_pzid;
                    this.zduid=data.i_zduid;

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getCompanyList(){
                let param={
                    i_mid: this.mid,
                    i_type:"2"
                };
                let res=await API.getCompanyList(param);
                if(res.code==1){
                    //this.currentDate()
                    if (res.data.length>0){
                        this.companyName=res.data;
                        this.formData.gsname=this.companyName[0].vc_name;
                        this.gsname=this.companyName[0].vc_name;
                        this.gsid=this.companyName[0].i_id;
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getCompanyListwt(){
                let param={
                    i_mid: this.mid,
                    i_type:"1"
                };
                let res=await API.getCompanyList(param);
                if(res.code==1){
                    this.wtcompanyName=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getGroupList(){
                let param={
                    i_mid: this.mid,
                    i_type: "1",
                };
                let res=await API.getGroupList(param);
                if(res.code==1){
                    this.groupName=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getPersonList(groupid){
                let param={
                    i_groupid:groupid,
                };
                let res=await API.getPersonList(param);
                if(res.code==1){
                    this.personName=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getWarehouseList(){
                let param={
                    i_mid: this.mid,
                };
                let res=await API.getWarehouseList(param);
                if(res.code==1){
                    if (res.data.length>0) {
                        this.warehouseName = res.data;
                        this.formData.ckname = this.warehouseName[0].vc_name;
                        this.ckname = this.warehouseName[0].vc_name;
                        this.ckid = this.warehouseName[0].i_id;
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getScorderPzList(){
                let param={
                    i_mid: this.mid,
                    i_cjid:this.cjid,
                };
                let res=await API.getScorderPzList(param);
                if(res.code==1){
                    this.proList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            changeCompany(val){
                //console.log("--gsis",val)
                if (this.formData.proname??''!==''){
                    this.formData.proname='';
                }
                this.gsid=val;
                if (val??''!==''){
                    let obj = this.companyName.find(item => item.i_id == val);
                    this.gsname = obj.vc_name;
                }else {
                    this.gsname='';
                }

            },
            changeCompanywt(val){
                //console.log("--gsis",val)
                if (this.formData.proname??''!==''){
                    this.formData.proname='';
                }
                this.wtgsid=val;
                if (val??''!==''){
                    let obj = this.wtcompanyName.find(item => item.i_id == val);
                    this.wtname = obj.vc_name;
                }else {
                    this.wtname='';
                }

            },
            changeWarehouse(val){
                this.ckid=val;
                if (val??''!==''){
                    let obj = this.warehouseName.find(item => item.i_id == val);
                    this.ckname = obj.vc_name;
                }else {
                    this.ckname='';
                }

            },
            changeGroup(val){
                // console.log(val,"======")
                // if (this.formData.zdname??''!==''){
                //     this.formData.zdname='';
                // }
                if (this.formData.proname??''!==''){
                    this.formData.proname='';
                }
                this.cjid=val;
                if (this.cjid??''!==''){
                    let obj = this.groupName.find(item => item.i_id == val);
                    this.cjname = obj.vc_name;
                    // this.getPersonList(this.cjid);
                    this.proList=[];
                    this.getScorderPzList(this.cjid);
                }else {
                    this.cjname ='';
                }
            },
            changePerson(perid){
                // this.zduid = perid;
                // if (perid??''!=='') {
                //     let obj = this.personName.find(item => item.i_id == perid);
                //     this.zdname = obj.vc_name;
                // }else {
                //     this.zdname ='';
                // }
            },
            changePro(val){
                //console.log("--gsis",val)
                this.pzid=val;
                if (val??''!=='') {
                    let obj = this.proList.find(item => item.i_id == val);
                    this.pzname = obj.vc_pzname;
                    this.$forceUpdate()
                }else {
                    this.pzname ='';
                }

            },
            async saveForm(){
              this.formData.delList=[]
                // console.log(this.formData.delList)

                // console.log(this.formData.saveList)
                    if(this.i_id==0){
                       this.saveList= this.formData.tableData.map(item=>({
                                i_id:0,
                                f_num:item.f_num,
                                i_lruid:sessionStorage.getItem("userid"),
                                i_pid:0,
                                dt_day:item.dt_day
                        }))
                        this.formData.delList=[]

                    }else {
                        if(this.deli_id==0){
                            this.formData.delList=[]
                        }

                        this.newdata=this.formData.tableData.map(item=>({

                            i_id:item.i_id,
                            f_num:item.f_num,
                            i_lruid:sessionStorage.getItem("userid"),
                            i_pid:item.i_pid,
                            dt_day:item.dt_day
                        }))
                        let arr1=this.olddata
                        let arr=[]
                        arr=this.newdata.filter(function(item){
                            return !arr1.some(ele=>ele.dt_day===item.dt_day&&ele.f_num===item.f_num)
                        })
                        this.saveList=arr
                    }


                if (this.formData.gsname==''){
                    this.$message.error(this.$t('form_please_select_a_processing_company'));
                    return
                }
                if (this.formData.wtname==''){
                    this.$message.error(this.$t('form_please_select_the_commissioning_company'));
                    return
                }
                if (this.formData.cjname==''){
                    this.$message.error(this.$t('form_please_select_department'));
                    return
                }
                // if (this.formData.zdname==''){
                //     this.$message.error("请选择制单人");
                //     return
                // }
                if (this.formData.proname==''){
                    this.$message.error(this.$t('form_please_select_a_product'));
                    return
                }
                if (this.formData.ckname==''){
                    this.$message.error(this.$t('form_warehouse'));
                    return
                }
                if (this.formData.f_num==''){
                    // console.log(this.formData.f_num=='')
                    this.$message.error(this.$t('promanagement_please_fill_in_the_quantity'));
                    return
                }
                let tablevalid=this.formData.tableData.filter(item=>{
                    return item.f_num==0||item.dt_day==0||item.dt_day==null
                })
                if(tablevalid.length!==0){
                    this.$message.error(this.$t('promanagement_please_fill_in_the_production_date_and_planned_quantity'));
                    return
                }
                // console.log()
                // returns
                this.disabled=true;
                let param={
                    i_mid: this.mid,
                    i_id:this.i_id,
                    i_gsid:this.wtgsid,
                    i_gsid_out:this.gsid,
                    i_cjid:this.cjid,
                    i_zduid:this.zduid,
                    vc_gsname:this.wtname,
                    vc_cjname:this.cjname,
                    vc_ckname:this.ckname,
                    vc_outgsname:this.gsname,
                    // vc_zduname:this.zdname,
                    vc_pzname:this.pzname,
                    i_ckid:this.ckid,
                    i_pzid:this.pzid,
                    vc_note:this.formData.vc_note,
                    // f_fcost_price:this.formData.jgcost,
                    i_type:1,
                    dt_createtime:this.formData.date,
                    list:this.saveList,
                    delIds:this.formData.delList,
                    dt_starttime:this.formData.begintime,
                    dt_endtime:this.formData.endtime,
                    f_num:this.formData.f_num
                    //i_lruid:this.i_lruid,
                    // i_lruid:42,
                    // vc_lruname:" zyh",
                    // vc_lruname:this.formData.vc_lruname,
                };
                let res=await API.saveScorder(param);
                if(res.code==1){
                    if(this.i_id!==0){
                        this.getScorder()

                    }
                    // this.$message.success(res.message);
                    this.disabled=true;
                    let data=res.scorder;
                    if(this.i_id==0){
                        this.taskList(data);

                    }
                    this.formData.delList=[]
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });
                    // this.i_id=res.scorder.i_id;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            taskList(data){
                // console.log("data",data);
                let val={
                    i_itype:this.i_type,
                    expanded: true,
                    data:data,
                }
                this.$emit('proDetails',val);
            },
            cancel(){},
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.formData.date=`${date.getFullYear()}-${month}-${strDate}`;
                //console.log(this.formData.date)
            },
            //得到最后一天
            getLastDay(val){
                let date=new Date(this.formData.begintime);
                date.setDate(28);
                date.setMonth(date.getMonth()+1);
                let lastDay=date.setDate(0);
                let allDay= new Date(lastDay).toString();
                const lastdate = new Date(allDay);
                const month = (lastdate.getMonth() + 1).toString().padStart(2, '0');
                const strDate = lastdate.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.lastTime=`${lastdate.getFullYear()}-${month}-${strDate}`;
                this.$set(this.formData, "endtime",this.lastTime)
                // console.log( value)
            },
        },
    }
</script>

<style lang="scss" scoped>
    .ed{
        min-width: 600px;
    }
    .flex{
        display: flex;
    }
    .item{
        width: 100%;
    }
    /deep/{
        .form-heji .el-form-item__label{
            font-weight: bold;
            color: black;
            font-size: 15px;
        }
        .num{
            margin-bottom: 12px;
        }
        .num .el-form-item__label {
            color: #b3d268;
            font-size: 16px;
            font-style: italic;
        }
        .num .el-form-item__content {
            width: 130px;
        }
        .el-tabs--border-card>.el-tabs__content{
            overflow: auto;
        }
        /*.el-table td,.el-table td, .el-table th {
            padding: 8px 0;
        }*/
        .danger-row{
            color: #999;

        }

    }

    /*@media screen and (max-height: 770px) {
        .video-tree {
            //width: 420px;
            height: 600px;
        }
    }
    @media screen and (min-height: 900px) {
        .video-tree {
            //width: 530px;
            height: 600px;
        }
    }
    @media screen and (min-height: 780px) and (max-height: 830px) {
        .video-tree {
            //width: 450px;
            height: 600px;
        }
    }

    //实现滚动功能
    .video-tree {
        overflow-y: auto;
    }*/

</style>